import { LoadingButton } from "@mui/lab";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";

const MigrateChatBot = ({ id }) => {
  const [phoneId, setPhoneId] = useState("");
  const [migrating, setMigrating] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <Paper variant="outlined" sx={{ p: 2, mt: 4 }}>
      <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="migration-content"
          id="migration-header"
        >
          <Typography variant="subtitle1">Chatbot Migration</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Stack gap={2}>
            <Alert severity="warning">
              <strong>Important:</strong> This action will permanently transfer
              the chatbot configuration from the specified phone number to your
              current account's phone number ID. Please verify both numbers
              carefully before proceeding.
            </Alert>

            <TextField
              value={phoneId}
              onChange={(e) => setPhoneId(e.target.value)}
              label="Source Phone Number ID"
              helperText="Enter the phone number ID you're migrating FROM"
              variant="outlined"
              size="small"
              fullWidth
            />

            <Alert severity="info">
              Your current account's phone number ID will be the DESTINATION of
              this migration. Ensure this is correct before proceeding.
            </Alert>

            <FormControlLabel
              control={
                <Checkbox
                  checked={confirmed}
                  onChange={(e) => setConfirmed(e.target.checked)}
                  color="primary"
                />
              }
              label="I have verified both source and destination phone numbers"
            />

            <LoadingButton
              variant="contained"
              loading={migrating}
              disabled={!phoneId || !confirmed}
              onClick={async () => {
                try {
                  setMigrating(true);
                  const response = await axios.put(
                    `${API_ENDPOINT}/partner/migrate-chatbot/${id}`,
                    { phone: phoneId },
                    getHeader()
                  );
                  toast.success(response.data.message);
                  setExpanded(false); // Collapse after successful migration
                } catch (error) {
                  toastError(error);
                } finally {
                  setMigrating(false);
                }
              }}
              sx={{ mt: 1 }}
            >
              Migrate Chatbot
            </LoadingButton>

            <Alert severity="info">
              <strong>Note:</strong> After migration, all chatbot configurations
              will be associated with your current account's phone number ID.
              The source phone number will no longer have these configurations.
            </Alert>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default MigrateChatBot;
